import {FC, memo} from "react";

import {RadioProps} from "./Radio-types";
import {Input, Label, Root} from "./Radio-styles";

/**
 * TODO: заменить data-type и data-transform на пропсы styled-компонента
 */
const Radio: FC<RadioProps> = memo((props) => {
    const {id, text, value, checked, buttonType, transformType, onClick} = props;

    return (
        <Root data-type={buttonType} data-transform={transformType}>
            <Input
                id={id}
                type="radio"
                onChange={() => onClick(value)}
                value={String(value)}
                checked={checked}
            />

            <Label htmlFor={id}>{text}</Label>
        </Root>
    )
});

export default Radio;
